import { ISearchPage } from '@/types/AppTypes';

//详情
export interface IOfferDetail {
	createUser?: string;
	createTime?: moment.Moment | null | string;
	id: string; // "ecf65d81b424438f937565cee152a7f5",
	code: string; // "询-111-21121400001",
	supplierOfferCode?: string; // "供应商报价单号",
	inquiryOrderCode?: string; // "询价单号",
	shopCode?: string; // "SHOP-M-00000020",
	shopName?: string; // "11",
	customerId?: string; // "07f5d7365fbcee467e7e9966d6cde9a3",
	customerCode?: string; // "CUS-M-00018473",
	customerName?: string; // "客户名称",
	contact?: string; // "客户联系人",
	phone?: string; // "客户电话",
	status?: string; // "状态",
	country?: string; // "贸易国别",
	offerTime?: moment.Moment | null | string; // "报价日期",
	termTime?: moment.Moment | null | string; // "有效日期",
	rmbAmount?: number | string; // 1,
	goodsAmount?: number | string; // 1,
	addAmount?: number | string; // 1,
	contractAmount?: number | string; // 1,
	exchangeRate?: string | number; // "汇率",
	discount?: string | number; // "整体上浮",
	//商品关联单价的上浮
	auhowPrice: string | number,
	upPrice: string | number,
	drawbackAmount: string | number,
	salePrice?: string | number,
	ytPrice: string | number,
	clause?: string; // "价格条款",
	transportMode?: string; // "运输方式",
	destination?: string; // "目的地",
	batches?: string | boolean; // "分批",
	transship?: string | boolean; // "转船",
	isMiddleman?: string | boolean; // "转船",
	shipment?: string; // "装货港",
	discharge?: string; // "卸货港",
	agentCompany?: string; // "代货公司",
	shippingMark?: string; // "唛头",
	advise?: string; // "审批意见1",
	adviseOne?: string; // "审批意见2",
	note?: string; // "备注",
	currencyCode?: string; // "币种",
	currencyName?: string; // "币种",
	typeNum?: string | number | number;
	updateTime?: moment.Moment | null | string;
	updateUser?: string;
	relevanceOrderId?: string;
	bentityCode?: string, bentityName?: string,
	details?: IOfferMaterialDetail[];
	detailsAdd?: IOfferDetailsAdded[];
	detailsPayment?: IOfferDetailMethod[];
	realCode?: string;
}

//询价单商品详情
export interface IOfferMaterialDetail {
	key: string;
	num: string | number; // 1,
	price: string | number; // 2,
	id?: string; // "报价单详情id",
	code?: string; // "报价单code",
	supplierOfferCode?: string; // "供应商报价code",
	inquiryOrderDetailsId?: string; // "询价单详情id",
	offerId?: string; // "报价单id",
	materialId?: string; // "物料id",
	materialCode?: string; // "物料编号",
	replaceCode?: string; // "替换号",
	materialName?: string; // "物料名称",
	materialEname?: string; // "物料名称英文",
	typeCode?: string; // "物料类型",
	typeName?: string; // "物料类型名称",
	amount: string | number; // 3,
	upPrice: string | number; // 1,
	upAmount: string | number; // 1,
	auhowPrice: string | number; // 1,
	auhowAmount: string | number; // 1,
	drawbackAmount: string | number; // 1,
	salePrice: string | number; // 1,
	saleAmount: string | number; // 1,
	tradePrice: string | number; // 1,
	tradeAmount: string | number; // 1,
	ytPrice: string | number; // 1,
	ytAmount: string | number; // 1,
	status?: string; // "状态",
	model?: string; // "规格",
	note?: string; // "备注"
	totalTxt?: string; // "备注"
	unitName?: string; // "备注"
	unitCode?: string; // "备注"
	customsCode?: string; // "备注"

}

//加收费用
export interface IOfferDetailsAdded {
	key: string;
	amount: string | number; //      50
	code?: string; //    "询-999-21121400001"
	createTime?: string; //          "2021-12-14T20?:string,
	createUser?: string; //          null
	currencyCode?: string | number; //            "币种"
	currencyAmount?: string | number; //            "币种"
	currencyName?: string; //            "币种"
	deleteFlag?: string; //          0
	ename?: string; //     "加收英文"
	id?: string; //  "1"
	name?: string; //    "加收费用"
	orderNum?: string; //        0
	updateTime?: string; //          "2021-12-14T20?:string,
	updateUser?: string; //         // null
	totalTxt?: string; //         // null

}

//收汇方式
export interface IOfferDetailMethod {
	key: string;
	amount?: string | number; // 65
	around?: string; // "或前"
	certificatesTime?: moment.Moment | null | string; // "预计收证日期"
	code?: string; // "询-999-21121400001"
	collectionTime?: moment.Moment | null | string; // "预计收款日期"
	createTime?: string; // "2021-12-14T20:45:38"
	createUser?: string; // null
	deleteFlag?: string; // 0
	id?: string; // "1"
	orderNum?: string; // 0
	paymentMethod?: string; // "收汇方式"
	paymentTime?: moment.Moment | null | string; // "日期"
	proportion?: string; // "比例"
	updateTime?: string; // "2021-12-14T20:46:29"
	updateUser?: string; // null
}

export interface IOtableMethod {
	key: string;
	createTime?: moment.Moment | null | string;
	updateTime?: moment.Moment | null | string;
}

//新增
export interface IOfferInsert extends IOfferDetail { }

//编辑
export interface IOfferUpdate extends IOfferInsert {
	id: string;
}

//搜索条件
export interface IOfferSearchFields {
	code?: string; // "询-",
	customerName?: string; // "客户",
	shopCode?: string; // "SHOP-M-00000020",
	status?: string; // "h-purchase-status.cancel",
	createUser?: string; // "管理"
}

export interface IOfferSearch extends IOfferSearchFields, ISearchPage { }

export interface IOfferExamine {
	id?: string; // "ecf65d81b424438f937565cee152a7f5",
	code?: string; // "ecf65d81b424438f937565cee152a7f5",
	status?: string; // "0",
	advise?: string; // "审批意见1111"
}
/**
 * 详情
 */
//tab枚举
export enum IOfferTabEnum {
	BASE_DETAIL = 'base_detail', //询价详情
	MATERIAL_INFO = 'material_info', //供应商报价
	RELEVANCE_TASK = 'relevance_task', //关联单据
	FILES = 'files', //附件管理
	AUDIT_DETAIL = 'Audit_detail', //审批明细
}


export interface IOfferDescType {
	numAll: number,
	amountAll: number,
	auhowAmount: number,
	upAmountAll: number,
	saleAmountAll: number,
	tradeAmountAll: number,
	ytAmountAll: number,
	addedAmountAll: number,
}
